import { Component, EventEmitter, HostListener, OnInit, Output, ChangeDetectorRef, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { RippleModule } from "primeng/ripple";
import { NotificationItem } from "@core/services/api/notification.service";

@Component({
  selector: "app-notification-popup",
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, RippleModule],
  templateUrl: "./notification-popup.component.html",
  styleUrls: ["./notification-popup.component.scss"],
})
export class NotificationPopupComponent implements OnInit {
  @Input() notifications: NotificationItem[] = [];
  @Input() unreadCount: number = 0;
  @Output() onClose = new EventEmitter<void>();
  @Output() markRead = new EventEmitter<number>();
  @Output() markAllRead = new EventEmitter<void>();

  showAll: boolean = true;
  isMobile: boolean = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void { this.checkDevice(); }

  @HostListener('window:resize')
  checkDevice(): void { this.isMobile = window.innerWidth < 1024; }

  get visibleNotifications() {
    const list = this.notifications || [];
    if (this.showAll) return list;
    return this.isMobile ? list.slice(0, 3) : list.slice(0, 6);
  }

  get showViewMore(): boolean {
    const list = this.notifications || [];
    const limit = this.isMobile ? 3 : 6;
    return list.length > limit && !this.showAll;
  }

  closePopup() { this.onClose.emit(); }
  viewMore() { this.showAll = true; this.cdr.detectChanges(); }
  markAsRead(id: number) { this.markRead.emit(id); }

  // placeholder for future implementation
  noop(): void {}
}

